/**
 * App Configuration
 * All configurable values sourced from environment variables.
 * Set REACT_APP_* vars in .env (local) or in your CI/CD pipeline.
 */

// Super admin email — controls who sees admin UI
export const SUPER_ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || 'kirtivarma@focusview.ai';

// API base URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.focusview.ai';

// Frontend base URL
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'https://www.focusview.ai';
